// ============================================
// GWP Cart Script — Haarspullen.nl
// ============================================

if (window.Shopify && window.Shopify.market && window.Shopify.market.handle !== 'nl') {
  throw new Error('GWP: niet-NL markt, script gestopt.');
}

var GWP_CAMPAIGNS = [
  { active: false, tag: 'gwp-wella-eimi',          giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo' },
  { active: false, tag: 'gwp-kms',                 giftVariantId: '57720099766646', giftHandle: 'therma-shape-quick-blow-dry-75ml' },
  { active: false,  tag: 'gwp-indola-hairpin',      giftVariantId: '57676128715126', giftHandle: 'indola-hairpin' },
  { active: true,  tag: 'gwp-ghd-toolbag',         giftVariantId: '56519708279158', giftHandle: 'ghd-tool-bag' },
  { active: false,  tag: 'gwp-blondme-set',         giftVariantId: '57794776072566', giftHandle: 'schwarzkopf-comb-mirror-set' },
  { active: false,  tag: 'gwp-maniac-topcoat',      giftVariantId: '56590815363446', giftHandle: 'maniac-top-coat-shine' },
  { active: false,  tag: 'gwp-gladskin-lipbalm',    giftVariantId: '57794984542582', giftHandle: 'everyday-lip-balm-spf30' },
{ active: true, tag: 'gwp-hairtowel', giftVariantId: '58324047987062', giftHandle: 'schwarzkopf-hair-towel', minTaggedCount: 2 },
{ active: true, tag: 'gwp-hairtowel-sets', giftVariantId: '58324047987062', giftHandle: 'schwarzkopf-hair-towel', minTaggedCount: 1 },
  { active: false,  tag: 'gwp-sebastian-kaars',     giftVariantId: '57798933315958', giftHandle: 'sebastian-dark-oil-geurkaars' },
  { active: false,  tag: 'gwp-mediceuticals-comb',  giftVariantId: '57728046268790', giftHandle: 'mediceuticals-scalpro-brush-buddy-comb-cleanser' },
  { active: false,  tag: 'gwp-olaplex-set',         giftVariantId: '57863213580662', giftHandle: 'olaplex-no-5-leave-in-travelsize' },
  { active: true, tag: 'gwp-bc-sunprotect',       giftVariantId: '57972553515382', giftHandle: 'bc-sun-beach-towel', minTaggedCount: 2 },
  { active: false, tag: 'gwp-blondme-towel',       giftVariantId: '56414070309238', giftHandle: 'schwarzkopf-hair-towel-wit' },
  { active: false, tag: 'gwp-tee-shampoo', giftVariantId: '57265067426166', giftHandle: 'schwarzkopf-fibre-clinix-hydrate-shampoo' },
{ active: false, tag: 'gwp-janzen-men', giftVariantId: '57838849229174', giftHandle: 'toillettas-mannen-gwp', minTaggedCount: 3 },
{ active: false, tag: 'gwp-janzen-set', giftVariantId: '57838849229174', giftHandle: 'toillettas-mannen-gwp', minTaggedCount: 1 },
{ active: false, tag: 'gwp-beachbag', giftVariantId: '58052123459958', giftHandle: 'schwarzkopf-beach-bag', minTaggedCount: 2 },
{ active: false, tag: 'gwp-beachbag-set', giftVariantId: '58052123459958', giftHandle: 'schwarzkopf-beach-bag', minTaggedCount: 1 },
{ active: true, tag: 'gwp-janzen-mist', giftVariantId: '58111784780150', giftHandle: 'body-mist-c-bergamot-fig-breeze-mini', minTaggedCount: 2 },
  { active: false, tag: 'gwp-attitude-spf', giftVariantId: '56327786955126', giftHandle: 'attitude-lip-balm-plastic-free', minTaggedCount: 2 },
{ active: true, tag: 'gwp-indola-beachbag', giftVariantId: '58095376400758', giftHandle: 'indola-beach-bag' },
{ active: false, tag: 'gwp-heatless-curls', giftVariantId: '57795020554614', giftHandle: 'schwarzkopf-heatless-curling-set', minTaggedCount: 3 },
{ active: false, tag: 'gwp-heatless-curls-sets', giftVariantId: '57795020554614', giftHandle: 'schwarzkopf-heatless-curling-set', minTaggedCount: 1 },
{ active: false, tag: 'gwp-bc-pouch', giftVariantId: '58186312614262', giftHandle: 'schwarzkopf-bc-sun-pouch', minTaggedCount: 2 },
{ active: false, tag: 'gwp-bc-pouch-sets', giftVariantId: '58186312614262', giftHandle: 'schwarzkopf-bc-sun-pouch', minTaggedCount: 1 },
{ active: false, tag: 'gwp-goldwell-bondisands', giftVariantId: '57687202267510', giftHandle: 'bondi-sands-after-sun-aloe-vera-cooling-gel', minTaggedCount: 3 },
{ active: false, tag: 'gwp-goldwell-bondisands-sets', giftVariantId: '57687202267510', giftHandle: 'bondi-sands-after-sun-aloe-vera-cooling-gel', minTaggedCount: 1 },
{ active: false, tag: 'gwp-kis-color', giftVariantId: '56414072602998', giftHandle: 'kis-protecting-shampoo', minTaggedCount: 3 },
{ active: false, tag: 'gwp-curlsmith', giftVariantId: '56327509901686', giftHandle: 'curl-smith-essential-moisture-conditioner', minTaggedCount: 1 },
{ active: true, tag: 'gwp-weleda', giftVariantId: '58148956701046', giftHandle: 'weleda-skin-food-creme', minTaggedCount: 1 },
{ active: true, tag: 'gwp-biosilk', giftVariantId: '56974786068854', giftHandle: 'biosilk-therapy-conditioner', minTaggedCount: 1 },
{ active: false, tag: 'gwp-wellaset', giftVariantId: '56327675216246', giftHandle: 'wella-ultimate-repair-masker', minTaggedCount: 1 },
{ active: false, tag: 'gwp-milkshake', giftVariantId: '56414076240246', giftHandle: 'lipgloss-caramel-brown', minTaggedCount: 1 },
{ active: true, tag: 'gwp-stmnt-grooming', giftVariantId: '57149404348790', giftHandle: 'stmnt-matte-paste', minTaggedCount: 2 },
{ active: true, tag: 'gwp-stmnt-grooming-sets', giftVariantId: '57149404348790', giftHandle: 'stmnt-matte-paste', minTaggedCount: 1 },
{ active: false, tag: 'gwp-wella-fusion', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo', minTaggedCount: 3 },
{ active: false, tag: 'gwp-wella-fusion-sets', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo', minTaggedCount: 1 },
{ active: false, tag: 'gwp-nioxin-kits', giftVariantId: '58393739067766', giftHandle: 'nioxin-pouch-gift', minTaggedCount: 1 },
{ active: true, tag: 'gwp-blondme-mini', giftVariantId: '58112334659958', giftHandle: 'schwarzkopf-cool-blondes-mask', minTaggedCount: 2 },
{ active: true, tag: 'gwp-blondme-mini-sets', giftVariantId: '58112334659958', giftHandle: 'schwarzkopf-cool-blondes-mask', minTaggedCount: 1 },
{ active: true, tag: 'gwp-indola-curls-sets', giftVariantId: '58411712086390', giftHandle: 'indola-curl-defining-brush', minTaggedCount: 1 },
{ active: false, tag: 'gwp-neofollics', giftVariantId: '58227588825462', giftHandle: 'neofollics-hair-wrap-towel', minTaggedCount: 2 },
{ active: true, tag: 'gwp-neofollics-sets', giftVariantId: '58227588825462', giftHandle: 'neofollics-hair-wrap-towel', minTaggedCount: 1 },
{ active: true, tag: 'gwp-fibresealer', giftVariantId: '58348251021686', giftHandle: 'schwarzkopf-fibre-clinix-fibre-sealer', minTaggedCount: 2 },
{ active: true, tag: 'gwp-fibresealer-sets', giftVariantId: '58348251021686', giftHandle: 'schwarzkopf-fibre-clinix-fibre-sealer', minTaggedCount: 1 },
{ active: true, tag: 'gwp-metamorphose', giftVariantId: '58135633396086', giftHandle: 'metamorphose-argan-nourishing-shampoo-1', minTaggedCount: 2 },
{ active: true, tag: 'gwp-metamorphose-sets', giftVariantId: '58135633396086', giftHandle: 'metamorphose-argan-nourishing-shampoo-1', minTaggedCount: 1 },
{ active: false, tag: 'gwp-olaplexno3', giftVariantId: '58504677032310', giftHandle: 'olaplex-no-3-hair-perfector-20ml', minTaggedCount: 2 },
{ active: false, tag: 'gwp-olaplexno3-sets', giftVariantId: '58504677032310', giftHandle: 'olaplex-no-3-hair-perfector-20ml', minTaggedCount: 1 },
{ active: true, tag: 'gwp-mediceuticalsdri', giftVariantId: '56327714046326', giftHandle: 'mediceuticals-bao-med-hair-mask', minTaggedCount: 1 },

// Wella EIMI Dry Me: losse producten tellen 1, sets van 2/3/4 tellen 2/3/4 (zie GWP_TAG_WEIGHTS)
{ active: false, tag: 'gwp-welladryme-weight', giftVariantId: '56328014987638', giftHandle: 'eimi-dry-me-droogshampoo', minTaggedCount: 4 },

// Wella-tiers op basis van gecombineerd gewicht (losse producten + sets tellen nu samen op)
{ active: false, tag: 'gwp-wella-weight', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo', minTaggedCount: 2 },
{ active: false, tag: 'gwp-wella-weight', giftVariantId: '56328013087094', giftHandle: 'wella-oil-reflections-luminous-smoothening-oil', minTaggedCount: 3 },
{ active: false, tag: 'gwp-wella-weight', giftVariantId: '56755987939702', giftHandle: 'giftvoucher-10', minTaggedCount: 4 },
];

// Gewicht per Wella-tag: losse producten en sets tellen nu op tot één totaal
var WELLA_TAG_WEIGHTS = {
  'gwp-wella-multibuy': 1,
  'gwp-wella-set-2pack': 2,
  'gwp-wella-set-3pack': 3,
  'gwp-wella-set-4pack': 4,
};

// Generieke gewogen tellers: campagne-tag => { product-tag: gewicht }
// De campagne-tag (bijv. 'gwp-welladryme-weight') wordt niet op producten gezet,
// alleen de product-tags hieronder.
var GWP_TAG_WEIGHTS = {
  'gwp-welladryme-weight': {
    'gwp-welladryme': 1,
    'gwp-welladryme-set-2pack': 2,
    'gwp-welladryme-set-3pack': 3,
    'gwp-welladryme-set-4pack': 4,
  },
};

// Alleen voor de voorraad-check van de productpagina-badges (los van cart-telling)
var GWP_BADGE_STOCK_CHECKS = [
  { tag: 'gwp-wella-multibuy', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo' },
  { tag: 'gwp-wella-set-2pack', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo' },
  { tag: 'gwp-wella-set-3pack', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo' },
  { tag: 'gwp-wella-set-4pack', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo' },
  // Dry Me: alle product-tags delen dezelfde overlay-klasse (.overlay-gwp-welladryme)
  { tag: 'gwp-welladryme', giftVariantId: '56328014987638', giftHandle: 'eimi-dry-me-droogshampoo' },
];

// Zet op true om de Wella 2/3/4-kortingsactie weer te activeren
var WELLA_TIERS_ACTIVE = false;

// Kortingscodes die de Wella-cadeaus daadwerkelijk op €0 zetten.
// Moeten al bestaan in Shopify Admin — het script kiest alleen welke van toepassing is.
var WELLA_TIER_DISCOUNT_CODES = {
  0: 'GWP-WELLA-CLEAR',   // geen tier behaald: eerdere code neutraliseren
  2: 'GWP-WELLA-TIER1',   // Fusion gratis
  3: 'GWP-WELLA-TIER2',   // Fusion + Oil gratis
  4: 'GWP-WELLA-TIER3',   // Fusion + Oil + Voucher gratis
};

// Wella EIMI Dry Me: kortingscode die de gift op €0 zet.
// GWP-DRYME moet in Shopify Admin bestaan (100% op alleen variant 56328014987638).
// Geen gift in de winkelmand? Dan wordt de bestaande neutrale code (GWP-WELLA-CLEAR) toegepast.
var DRYME_DISCOUNT_ACTIVE = true;
var DRYME_VARIANT_ID = '56328014987638';
var DRYME_DISCOUNT_CODE = 'GWP-DRYME';
var DRYME_CLEAR_CODE = 'GWP-WELLA-CLEAR';

// ============================================
// Logica — niet aanpassen
// ============================================

var gwpRunning = false;   // er loopt nu een controle
var gwpPending = false;   // er kwam een signaal binnen tijdens een controle -> daarna nog 1x draaien
var gwpFetching = false;  // eigen add/update-calls (die mag de fetch-onderschepping negeren)
var gwpTimer = null;

// Productgegevens (tags + voorraad) komen uit één gedeelde cache.
// We cachen de PROMISE, zodat gelijktijdige aanvragen voor hetzelfde product maar 1 request zijn.
var GWP_CACHE_TTL = 60000; // 60 seconden
var gwpProductCache = {};

function gwpGetProduct(handle) {
  var entry = gwpProductCache[handle];
  if (entry && Date.now() - entry.t < GWP_CACHE_TTL) return entry.p;
  var p = fetch('/products/' + handle + '.js')
    .then(function(r) { return r.json(); })
    .catch(function() { return null; })
    .then(function(product) {
      // Mislukte aanvraag niet in de cache laten staan
      if (!product && gwpProductCache[handle] && gwpProductCache[handle].p === p) {
        delete gwpProductCache[handle];
      }
      return product;
    });
  gwpProductCache[handle] = { t: Date.now(), p: p };
  return p;
}

function gwpGetCart() {
  return fetch('/cart.js').then(function(r) { return r.json(); });
}
function gwpAddToCartBatch(variantIds) {
  if (!variantIds.length) return Promise.resolve();
  gwpFetching = true;
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: variantIds.map(function(id) { return { id: id, quantity: 1, properties: { _gwp: 'true' } }; })
    }),
  }).finally(function() { gwpFetching = false; });
}

function gwpRemoveFromCartBatch(variantIds) {
  if (!variantIds.length) return Promise.resolve();
  gwpFetching = true;
  var updates = {};
  variantIds.forEach(function(id) { updates[id] = 0; });
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: updates }),
  }).finally(function() { gwpFetching = false; });
}

async function gwpIsGiftAvailable(handle, variantId) {
  var product = await gwpGetProduct(handle);
  if (!product) return false;
  for (var i = 0; i < product.variants.length; i++) {
    if (String(product.variants[i].id) === String(variantId)) {
      return product.variants[i].available;
    }
  }
  return false;
}

async function gwpGetProductTags(handle) {
  var product = await gwpGetProduct(handle);
  return (product && product.tags) || [];
}

function gwpWellaTierCodeForWeight(weight) {
  if (weight >= 4) return WELLA_TIER_DISCOUNT_CODES[4];
  if (weight === 3) return WELLA_TIER_DISCOUNT_CODES[3];
  if (weight === 2) return WELLA_TIER_DISCOUNT_CODES[2];
  return WELLA_TIER_DISCOUNT_CODES[0];
}

function gwpSetCartAttribute(key, value) {
  var attrs = {};
  attrs[key] = value;
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attrs }),
  });
}

function gwpApplyDiscountCode(code) {
  var redirectTo = window.location.pathname + window.location.search;
  window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectTo);
}

// Eén controle. Geeft true terug als de pagina daarna herlaadt/wegnavigeert.
async function gwpRun() {
  var cart = await gwpGetCart();

  var giftMap = {};
  for (var i = 0; i < GWP_CAMPAIGNS.length; i++) {
    var camp = GWP_CAMPAIGNS[i];
    if (!camp.active) continue;
    var vid = String(camp.giftVariantId);
    if (!giftMap[vid]) giftMap[vid] = { campaigns: [], giftHandle: camp.giftHandle };
    giftMap[vid].campaigns.push(camp);
  }

  var uniqueTags = {};
  for (var gi = 0; gi < GWP_CAMPAIGNS.length; gi++) {
    if (GWP_CAMPAIGNS[gi].active) uniqueTags[GWP_CAMPAIGNS[gi].tag] = true;
  }

  var relevantItems = cart.items.filter(function(item) {
    return !(item.properties && item.properties._gwp === 'true');
  });

  // Tags van alle unieke handles parallel ophalen (uit de cache waar mogelijk)
  var uniqueHandles = {};
  relevantItems.forEach(function(item) { uniqueHandles[item.handle] = true; });
  var handleList = Object.keys(uniqueHandles);
  var tagLists = await Promise.all(handleList.map(gwpGetProductTags));
  var tagsByHandle = {};
  handleList.forEach(function(h, idx) { tagsByHandle[h] = tagLists[idx]; });

  var tagCounts = {};
  var wellaWeight = 0;
  var weightedCounts = {};
  for (var j = 0; j < relevantItems.length; j++) {
    var item = relevantItems[j];
    var tags = tagsByHandle[item.handle] || [];
    for (var tag in uniqueTags) {
      if (!tagCounts[tag]) tagCounts[tag] = 0;
      if (tags.includes(tag)) tagCounts[tag] += item.quantity;
    }
    // Gecombineerd Wella-gewicht: losse producten + sets tellen nu samen op
    for (var wtag in WELLA_TAG_WEIGHTS) {
      if (tags.includes(wtag)) {
        wellaWeight += WELLA_TAG_WEIGHTS[wtag] * item.quantity;
      }
    }
    // Generieke gewogen tellers (bijv. Dry Me: los = 1, set-2pack = 2, ...)
    for (var vtag in GWP_TAG_WEIGHTS) {
      if (!uniqueTags[vtag]) continue;
      for (var ptag in GWP_TAG_WEIGHTS[vtag]) {
        if (tags.includes(ptag)) {
          weightedCounts[vtag] = (weightedCounts[vtag] || 0) + GWP_TAG_WEIGHTS[vtag][ptag] * item.quantity;
        }
      }
    }
  }
  tagCounts['gwp-wella-weight'] = wellaWeight;
  for (var wk in weightedCounts) tagCounts[wk] = weightedCounts[wk];

  // Eerste ronde: per gift bepalen of de actie verdiend is en of het cadeau al in de winkelwagen zit
  var giftVariantIds = Object.keys(giftMap);
  var giftInfo = {};
  giftVariantIds.forEach(function(giftVariantId) {
    var campaigns = giftMap[giftVariantId].campaigns;

    var giftInCart = null;
    for (var k = 0; k < cart.items.length; k++) {
      var cartItem = cart.items[k];
      if (String(cartItem.variant_id) === giftVariantId &&
          cartItem.properties && cartItem.properties._gwp === 'true') {
        giftInCart = cartItem;
      }
    }

    var anyTriggered = false;
    for (var c2 = 0; c2 < campaigns.length; c2++) {
      var minRequired = campaigns[c2].minTaggedCount || 1;
      if ((tagCounts[campaigns[c2].tag] || 0) >= minRequired) {
        anyTriggered = true;
        break;
      }
    }

    giftInfo[giftVariantId] = {
      qty: giftInCart ? giftInCart.quantity : 0,
      anyTriggered: anyTriggered
    };
  });

  // Voorraad alleen checken voor cadeaus waar het ertoe doet:
  // verdiend, of al in de winkelwagen. Voor de rest verandert er niets, dus geen request nodig.
  var needCheck = giftVariantIds.filter(function(gv) {
    return giftInfo[gv].anyTriggered || giftInfo[gv].qty > 0;
  });
  var availabilityList = await Promise.all(needCheck.map(function(gv) {
    return gwpIsGiftAvailable(giftMap[gv].giftHandle, gv);
  }));
  var availabilityMap = {};
  needCheck.forEach(function(gv, idx) { availabilityMap[gv] = availabilityList[idx]; });

  var toAdd = [];
  var toRemove = [];
  var giftWanted = {};

  for (var g = 0; g < giftVariantIds.length; g++) {
    var giftVariantId = giftVariantIds[g];
    var currentGiftQty = giftInfo[giftVariantId].qty;
    var anyTriggered = giftInfo[giftVariantId].anyTriggered;

    // Niet verdiend en niet in de winkelwagen: niets te doen
    if (!anyTriggered && currentGiftQty === 0) {
      giftWanted[giftVariantId] = false;
      continue;
    }

    var giftAvailable = availabilityMap[giftVariantId];
    giftWanted[giftVariantId] = !!(anyTriggered && giftAvailable);

    if (!giftAvailable) {
      if (currentGiftQty > 0) toRemove.push(giftVariantId);
      continue;
    }

    if (anyTriggered && currentGiftQty === 0) {
      toAdd.push(giftVariantId);
    } else if (anyTriggered && currentGiftQty > 1) {
      toRemove.push(giftVariantId);
      toAdd.push(giftVariantId);
    } else if (!anyTriggered && currentGiftQty > 0) {
      toRemove.push(giftVariantId);
    }
  }

  var needsReload = toAdd.length > 0 || toRemove.length > 0;

  // Eén batch-verwijdering, dan één batch-toevoeging
  if (toRemove.length) await gwpRemoveFromCartBatch(toRemove);
  if (toAdd.length) await gwpAddToCartBatch(toAdd);

  // Wella-kortingscode: zorgt dat de juiste tier ook echt op €0 komt
  if (WELLA_TIERS_ACTIVE) {
    var desiredWellaCode = gwpWellaTierCodeForWeight(wellaWeight);
    var currentWellaCode = (cart.attributes && cart.attributes._gwp_wella_tier) || WELLA_TIER_DISCOUNT_CODES[0];

    if (desiredWellaCode !== currentWellaCode) {
      await gwpSetCartAttribute('_gwp_wella_tier', desiredWellaCode);
      gwpApplyDiscountCode(desiredWellaCode); // navigeert weg, dus geen reload nodig hierna
      return true;
    }
  }

  // Dry Me-kortingscode: gift op €0 zolang de gift verdiend is, anders neutraliseren.
  // Draait alleen als de Wella-tiers uit staan, anders strijden twee codes om hetzelfde slot.
  if (DRYME_DISCOUNT_ACTIVE && !WELLA_TIERS_ACTIVE) {
    var desiredDryMeCode = giftWanted[DRYME_VARIANT_ID] ? DRYME_DISCOUNT_CODE : DRYME_CLEAR_CODE;
    var currentDryMeCode = (cart.attributes && cart.attributes._gwp_dryme_code) || DRYME_CLEAR_CODE;

    if (desiredDryMeCode !== currentDryMeCode) {
      await gwpSetCartAttribute('_gwp_dryme_code', desiredDryMeCode);
      gwpApplyDiscountCode(desiredDryMeCode); // navigeert weg, dus geen reload nodig hierna
      return true;
    }
  }

  if (needsReload) {
    location.reload();
    return true;
  }

  return false;
}

// Er draait maximaal één controle tegelijk. Komt er tijdens een controle een nieuw signaal binnen
// (bijv. de winkelwagen verandert nog), dan draait er daarna precies één keer een nieuwe.
async function updateGWP() {
  if (gwpRunning) { gwpPending = true; return; }
  gwpRunning = true;
  var leaving = false;
  try {
    leaving = await gwpRun();
  } catch (e) {
    console.error('GWP error:', e);
  }
  if (leaving) return; // pagina herlaadt of navigeert weg
  gwpRunning = false;
  if (gwpPending) {
    gwpPending = false;
    gwpSchedule();
  }
}

// Meerdere signalen vlak na elkaar (cart:updated + cart:refresh + onderschepte request) worden één controle
function gwpSchedule() {
  clearTimeout(gwpTimer);
  gwpTimer = setTimeout(updateGWP, 100);
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(updateGWP, 300);
});

document.addEventListener('cart:updated', gwpSchedule);
document.addEventListener('cart:refresh', gwpSchedule);

var _fetch = window.fetch;
window.fetch = function() {
  var args = arguments;
  return _fetch.apply(this, args).then(function(res) {
    if (gwpFetching) return res;
    var url = typeof args[0] === 'string' ? args[0] : '';
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
      gwpSchedule();
    }
    return res;
  });
};

// Productpagina badge voorraad check (gebruikt dezelfde cache als hierboven)
(function() {
  var checks = GWP_CAMPAIGNS.concat(GWP_BADGE_STOCK_CHECKS);
  checks.forEach(function(campaign) {
    if (campaign.active === false || !campaign.giftHandle) return;
    var selector = '.overlay-gwp-' + campaign.tag.replace('gwp-', '');
    var el = document.querySelector(selector);
    if (!el) return;
    gwpGetProduct(campaign.giftHandle).then(function(p) {
      if (!p) return;
      var available = p.variants.some(function(v) {
        return String(v.id) === String(campaign.giftVariantId) && v.available;
      });
      if (!available) el.style.display = 'none';
    });
  });
})();